interface MetaTag {
  name: string
  content: string
}

interface LinkTag {
  rel: string
  href: string
  as?: string
  crossOrigin?: string
  fetchPriority?: 'high' | 'low' | 'auto'
}

/**
 * MOCKUP OFICIAL del producto (Impultienda). Es el elemento LCP del hero y se
 * reutiliza en la sección de oferta. No aplicar filtros que alteren sus colores.
 */
export const HERO_IMAGE_URL =
  'https://cdn.magicpatterns.com/uploads/wwCm1P5TQVZXNWkf6tndht/Mock_up.png'

/** Manos armando una caja de postres en una cocina luminosa ("Para quién es"). */
export const AUDIENCE_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/69f8e013-b4f5-481e-9507-885de689655b.jpg'

/** Surtido de postres comerciales (sección de recetas). */
export const RECIPES_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/2f59e8e1-7999-4ca9-8e0e-bc358179b8d0.jpg'

/** Packaging moderno (sección de boxes y combos). */
export const PACKAGING_IMAGE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/7f797ba4-d282-477b-8094-17b8582d697a.jpg'

/** La sección de oferta muestra el mockup oficial del producto. */
export const BUNDLE_IMAGE_URL = HERO_IMAGE_URL

const PAGE_TITLE = 'Postres que Venden™ — Empezá a vender postres desde tu cocina'

const META_TAGS: MetaTag[] = [
  {
    name: 'description',
    content:
      'Postres que Venden™: sistema práctico + 60 recetas comerciales + Método M.V.P.™ para elegir qué preparar, organizar tu producción, calcular costos, presentar tus productos y empezar a vender postres desde tu casa.',
  },
]

const LINK_TAGS: LinkTag[] = [
  // Warm up the font + image origins before the CSS/image requests are made.
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
  { rel: 'preconnect', href: 'https://cdn.magicpatterns.com' },
  // Discover the LCP image as early as possible, at high priority.
  { rel: 'preload', href: HERO_IMAGE_URL, as: 'image', fetchPriority: 'high' },
]

/**
 * Inserts global <meta> and resource-hint <link> tags into <head> once.
 * Existing tags are never duplicated.
 */
export function initHeadMeta(): void {
  if (typeof document === 'undefined') return

  document.title = PAGE_TITLE

  META_TAGS.forEach(({ name, content }) => {
    if (document.querySelector(`meta[name="${name}"]`)) return

    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.head.appendChild(meta)
  })

  LINK_TAGS.forEach(({ rel, href, as, crossOrigin, fetchPriority }) => {
    if (document.querySelector(`link[rel="${rel}"][href="${href}"]`)) return

    const link = document.createElement('link')
    link.rel = rel
    link.href = href
    if (as) link.as = as
    if (crossOrigin) link.crossOrigin = crossOrigin
    if (fetchPriority) link.setAttribute('fetchpriority', fetchPriority)
    document.head.appendChild(link)
  })
}
